export default "__VITE_PUBLIC_ASSET__ed6057ab__"